import type { FC } from 'react'
import Image from '~/components/image/Image'
import type { FragmentType } from '~/lib/graphql'
import { getFragmentData } from '~/lib/graphql'
import { css, sva } from '~/styled-system/css'
import { SupremeRestaurant } from './SupremeRestaurant.frag'

export const IkyuOnlySupremeRestaurantBanner: FC<Props> =
  import.meta.env.VITE_MODE === 'ppg' ? EmptySupremeRestaurantBanner : SupremeRestaurantBanner

function EmptySupremeRestaurantBanner() {
  return null
}

type Size = 'narrow' | 'wide'

type Props = {
  restaurant: FragmentType<typeof SupremeRestaurant>
  size: Size
}

const imageProps: Record<Size, { src: string; width: number; height: number }> = {
  narrow: {
    src: 'https://restaurant.img-ikyu.com/rsImg/banner/supreme_sd.jpg',
    width: 350,
    height: 90,
  },
  wide: {
    src: 'https://restaurant.img-ikyu.com/rsImg/banner/supreme.jpg',
    width: 240,
    height: 120,
  },
}

const styles = sva({
  slots: ['image'],
  variants: {
    size: {
      narrow: {
        image: { w: 'full' },
      },
      wide: {
        image: {},
      },
    },
  },
})

function SupremeRestaurantBanner({ restaurant, size }: Props) {
  if (!getFragmentData(SupremeRestaurant, restaurant).isSupreme) {
    return null
  }

  const classes = styles({ size })
  return (
    <aside className={css({ p: '3', _pc: { p: '0' } })}>
      <a href="/specials/supreme/" className={css({ _pc: { display: 'inline-block' } })}>
        <Image
          src={imageProps[size].src}
          alt="一休.comレストラン厳選の名店、人気店 至高のレストラン"
          width={imageProps[size].width}
          height={imageProps[size].height}
          className={classes.image}
        />
      </a>
    </aside>
  )
}
